"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowEditor = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_ui_1 = require("@sierralabs/core-ui");
const TaskTypeListPanel_1 = __importDefault(require("../task-types/components/TaskTypeListPanel"));
const WorkflowBuilderContext_1 = require("../WorkflowBuilderContext");
const WorkflowEditPanel_1 = require("./WorkflowEditPanel");
const WorkflowListPanel_1 = __importDefault(require("./WorkflowListPanel"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  .editor-container {
    flex: 1;
  }
  .navigation-pane {
    min-width: 240px;
  }
  .workflow-pane {
    overflow: auto;
  }
  .flex {
    flex: 1;
  }
`;
const WorkflowEditor = () => {
    return (react_1.default.createElement(WorkflowBuilderContext_1.WorkflowBuilderProvider, null,
        react_1.default.createElement(StyledDiv, { className: 'workflow-editor' },
            react_1.default.createElement(core_ui_1.SplitPane, { className: 'editor-container' },
                react_1.default.createElement(core_ui_1.SplitPane, { width: 240, primary: 'next', className: 'navigation-pane' },
                    react_1.default.createElement(core_ui_1.SplitPane, { direction: 'vertical' },
                        react_1.default.createElement(core_ui_1.SplitPane, { height: '50%', className: 'route-pane' },
                            react_1.default.createElement(WorkflowListPanel_1.default, null)),
                        react_1.default.createElement(core_ui_1.Pane, { className: 'route-component-pane' },
                            react_1.default.createElement(TaskTypeListPanel_1.default, null)))),
                react_1.default.createElement(core_ui_1.Pane, { className: 'workflow-pane' },
                    react_1.default.createElement(WorkflowEditPanel_1.WorkflowEditPanel, null))))));
};
exports.WorkflowEditor = WorkflowEditor;
exports.default = exports.WorkflowEditor;
//# sourceMappingURL=WorkflowEditor.js.map